export default __webpack_public_path__ + "static/media/headshot-transparent.07e4d869.png";